// extracted by mini-css-extract-plugin
export default {"tooltip":"qo-z","sharingV2":"ro-z","sharingIconsV2":"so-z","links":"to-z","link":"uo-z","facebookV2":"vo-z","twitterV2":"wo-z","pinterestV2":"xo-z"};